<template>
  <Layout>
    <b-row class="row-padding text-center">
      <b-col>
        <h1 class="title">Identificadores</h1>
      </b-col>
    </b-row>
    <Form>
      <Tabs :menus="panelMenus">
        <template v-slot:0>
          <div>
            <b-row class="align-items-end">
              <b-col md="4">
                <Input
                  id="identifier1"
                  label="Identificador 1"
                  labelBold
                  :maxlength="30"
                  v-model="osIdentifiers.identifier1"
                />
              </b-col>
              <b-col md="4">
                <Input
                  id="identifier2"
                  label="Identificador 2"
                  labelBold
                  :maxlength="30"
                  v-model="osIdentifiers.identifier2"
                />
              </b-col>
              <b-col md="4">
                <Input
                  id="identifier3"
                  label="Identificador 3"
                  labelBold
                  :maxlength="30"
                  v-model="osIdentifiers.identifier3"
                />
              </b-col>
            </b-row>
            <b-row class="align-items-end">
              <b-col md="4">
                <Input
                  id="identifier4"
                  label="Identificador 4"
                  labelBold
                  :maxlength="30"
                  v-model="osIdentifiers.identifier4"
                />
              </b-col>
              <b-col md="4">
                <Input
                  id="identifier5"
                  label="Identificador 5"
                  labelBold
                  :maxlength="30"
                  v-model="osIdentifiers.identifier5"
                />
              </b-col>
              <b-col md="4">
                <Input
                  id="identifier6"
                  label="Identificador 6"
                  labelBold
                  :maxlength="30"
                  v-model="osIdentifiers.identifier6"
                />
              </b-col>
            </b-row>
          </div>
        </template>
      </Tabs>
      <FooterForm @submit="save" :hasCancel="false" />
    </Form>
  </Layout>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { Layout, Tabs, Input } from '@/components';
import { Form, FooterForm } from '@/components/Form';

export default {
  name: 'ServiceOrderIdentifiers',
  components: {
    Input,
    Layout,
    Form,
    FooterForm,
    Tabs,
  },
  data() {
    return {
      panelMenus: [{ id: 0, label: 'Geral' }],
    };
  },
  async mounted() {
    this.setLoading(true);
    await this.setIdentifiers();
    this.setLoading(false);
  },
  computed: {
    ...mapState('osIdentifiers', ['osIdentifiers']),
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    ...mapActions('osIdentifiers', ['setIdentifiers', 'updateOsIdentifiers']),

    async save() {
      try {
        this.setLoading(true);
        await this.updateOsIdentifiers(this.osIdentifiers);
        this.$alert.success('Identificadores salvos com sucesso.');
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
